module.exports = __webpack_public_path__ + "img/seaman.e964c68d.svg";